import { HIDE_REC_TECH_INTERNAL_ID } from 'common/constants';
import { useHideSomeExperiment } from './use-hide-some-experiment';

export function useHideRecTech() {
  const isHideRecTech = useHideSomeExperiment(HIDE_REC_TECH_INTERNAL_ID);

  return isHideRecTech;
}
